import axios from 'axios'
import config from '../config'
let globalHeader = JSON.parse(localStorage.getItem('newAjaxHeader'))

if (globalHeader) {
  window.sessionStorage.setItem('userId', globalHeader.userId)
}

let post = (cmd, params, callback, complete, fail) => {
  // console.log(cmd)
  let url = config.host
  let header = globalHeader || {
    appId: '100003',
    platform: 3,
    device: {}
  }
  complete = complete || function () { }
  delete header.requestName
  delete header.appRequestName
  header.appRequestName = cmd
  if (cmd == 'GetTeachResourceTypeRequest') {
    console.log('GetTeachResourceTypeRequest params', params)
  }
  if (cmd == 'GetDigitalBookByIdRequest') {
    console.log('GetDigitalBookByIdRequest params', params)
  }
  axios.post(url, {
    header: header,
    request: params
  }, {
    withCredentials: true
  }).then((res) => {
    complete(res.data)
    let retCode = res.data.result.retCode
    switch (retCode) {
      case 0:
        if (typeof callback === 'function') {
          callback(res.data)
        }
        break
      case 100103:
      case 100104:// token失效、用户无效
        window.app.$message({
          message: '登录态已过期，请重新登录',
          type: 'error'
        })

        if (window.localStorage) {
          window.localStorage.clear()
        }
        location.hash = '/'
        break
      case 410001:// 书本无效、下架
        break
      case -7:// 超时
        break
      case 411002: // 验证码不正确
        window.app.$message({
          message: '验证码不正确',
          type: 'error'
        })
        break
      default:
        window.app.$message({
          message: '数据请求失败，请稍后再试',
          type: 'error'
        })
    };
  }).catch((res) => {
    // console.log(res)
    if (typeof fail == 'function') fail(res)
  })
}

let modPost = (cmd, params, callback, complete) => {
  // console.log(cmd)
  let url = config.host
  let header = globalHeader || {
    appId: '100003',
    platform: 3,
    device: {}
  }
  complete = complete || function () { }
  delete header.requestName
  delete header.appRequestName
  header.requestName = cmd
  axios.post(url, {
    header: header,
    request: params
  }, {
    withCredentials: true
  }).then((res) => {
    complete(res.data)
    let retCode = res.data.result.retCode
    // let msg = res.data.result.msg || '数据请求失败，请稍后再试'
    switch (retCode) {
      case 0:
        if (typeof callback === 'function') {
          callback(res.data)
        };
        break
      case 100103:
      case 100104:// token失效、用户无效
        window.app.$message({
          message: '登录态已过期，请重新登录',
          type: 'error'
        })
        if (window.localStorage) {
          window.localStorage.clear()
        }
        window.app.globalData.userInfo = undefined
        location.hash = '/'
        break
      case 410001:// 书本无效、下架
        break
      case -7:// 超时
        break
      default:
        window.app.$message({
          message: '数据请求失败，请稍后再试',
          type: 'error'
        })
    };
  }).catch((res) => {
    // debugger
    // console.log(res)
  })
}

let aliPost = (cmd, params, callback, complete) => {
  // console.log(cmd)
  let url = config.host
  let header = globalHeader || {
    appId: '100003',
    platform: 3,
    device: {}
  }
  complete = complete || function () { }
  delete header.requestName
  delete header.appRequestName
  header.requestName = cmd
  console.log(params)
  axios.post(url, {
    header: header,
    request: params
  }, {
    withCredentials: true
  }).then((res) => {
    complete(res.data)
    let retCode = res.data.result.retCode
    // let msg = res.data.result.msg || '数据请求失败，请稍后再试'
    switch (retCode) {
      case 0:
        if (typeof callback === 'function') {
          callback(res.data)
        };
        break
      case 100103:
      case 100104:// token失效、用户无效
        window.app.$message({
          message: '登录态已过期，请重新登录',
          type: 'error'
        })
        if (window.localStorage) {
          window.localStorage.clear()
        }
        window.app.globalData.userInfo = undefined
        location.hash = '/'
        break
      case 410001:// 书本无效、下架
        break
      case -7:// 超时
        break
      default:
        window.app.$message({
          message: '数据请求失败，请稍后再试',
          type: 'err'
        })
    };
  }).catch((res) => {
    // debugger
    // console.log(res)
  })
}

let getTeacherInfo = (callback, complete, fail) => {
  post('GetTeacherInfoRequest', {}, (res) => {
    res.body.subjectName = ['英语', '数学', '语文'][res.body.moduleType]
    window.sessionStorage.setItem('userInfo', JSON.stringify(res.body))
    callback(res.body)
  }, complete, fail)
}

let login = (code, callback, error) => {
  axios.post(config.host, {
    header: {
      appId: '100003',
      platform: 3,
      device: {},
      requestName: 'LoginWechatRequest',
      ext: {
        wxAppId: config.appId
      }
    },
    request: {
      wxLoginCode: code
    }
  }, {
    withCredentials: true
  }).then((res) => {
    if (res.data.result.retCode === 0) {
      window.app.$message({
        message: '登录成功',
        type: 'success'
      })
      if (!window.app.globalData) {
        window.app.globalData = {}
      }
      globalHeader = res.data.header
      if (window.localStorage) {
        window.localStorage.setItem('newAjaxHeader', JSON.stringify(res.data.header))
      }
      window.sessionStorage.setItem('userId', res.data.header.userId)
      location.hash = '/index'
      callback(res.data)
    } else {
      error(res)
      window.app.$message({
        message: res.data.result.msg,
        type: 'error'
      })
      location.hash = '/'
    }

    callback(res)
  }).catch((res) => {
    // console.log(res)
  })
}

export default {
  post,
  modPost,
  getTeacherInfo,
  login,
  globalHeader,
  aliPost
}
